module.exports = "/assets/data/ead01fa6b587dc7e07b161749bd855b2-SN2.data.json";